import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react';
import axios from 'axios';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Appconfig from '../../config/config'
import Loader from 'components/loader';
const FooterNav = ({ rightMenu, setRightMenu, leftMenu, setLeftMenu, isLoginModalOpen, setIsLoginModalOpen }) => {
    const location = useLocation();
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [loaderLoading, setLoaderLoading] = useState(false);
    const openSidebar = () => {
        if (isAuthenticated) {
            setRightMenu(true);
        }
        else {
            setIsLoginModalOpen(true);
        }
    }
    function CreateAndLaunchWCOCasino(provider_code, game_code, type) {
        if (!isAuthenticated) {
            NotificationManager.error('Please login to play.', '', 1000);
            return;
        }
        setLoaderLoading(true);
        if (profileData?.is_casino_bet_lock == 'Yes') {
            NotificationManager.error('Casino Block By Upline.', '', 1000);
            setLoaderLoading(false);
            return;
        }
        const userData = {
            user_id: profileData?._id,
            user_name: profileData?.user_name,
            redirect_url: window.location.href,
            provider_code: provider_code,
            game_code: game_code,
            type: type,
        };

        var config = {
            method: "post",
            url: `${Appconfig.casinoUrl}wco/login`,
            headers: {
                "Content-Type": "application/json",
            },

            data: JSON.stringify(userData),
        };

        axios(config)
            .then(function (response) {
                let status = response.data.status?.code;
                console.log('status:', status)
                if (status === "SUCCESS") {
                    window.open(response.data.launchURL, "_self");
                    setLoaderLoading(false);
                }

                if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
                    NotificationManager.error('Game Not Found.', '', 1000);
                    setLoaderLoading(false);
                } else if (status == "AUTHENTICATION_FAILED") {
                    NotificationManager.error(response.data.status?.message, '', 1000);
                    setLoaderLoading(false);
                }
                if (status == "LOGIN_FAILED") {
                    NotificationManager.error(response?.data?.status?.message, '', 1000);
                    setLoaderLoading(false);
                }
                setLoaderLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoaderLoading(false);
            });
    }
    return (
        <>
            {loaderLoading && <Loader />}
            <div className='footer-menu !h-[50px]'>
                <div className='wrapper '>
                    <div className={`button-f ${location.pathname == '/' || location.pathname == '/home' ? 'active' : ''}`}>
                        <Link to={'/'} className='flex items-center'>
                            <div className="icon">
                                <img src="/assets/svg/home.svg" alt="" />
                            </div>
                            <span>Home</span>
                        </Link>
                    </div>
                    <div className={`button-f ${location.pathname == '/inplay' ? 'active' : ''}`}>
                        <Link to={'/inplay'} className='flex items-center'>
                            <div className="icon">
                                <img src="/assets/svg/inplay.svg" alt="" />
                            </div>
                            <span>Inplay</span>
                        </Link>
                    </div>
                    <div className={`button-f `}>
                        <button onClick={() => isAuthenticated ? CreateAndLaunchWCOCasino() : setIsLoginModalOpen(true)} className='flex items-center'>
                            <div className="icon">
                                <img src="/assets/images/mini_games.gif" alt="" />
                            </div>
                            <span>MiniGame</span>
                        </button>
                    </div>
                    <div className="button-f" onClick={openSidebar}>
                        <div className="icon">
                            <img src="/assets/svg/menu.svg" alt="" />
                        </div>
                        <span>Menu</span>
                    </div>
                </div>
            </div>
        </>
    )
}
export default FooterNav